import { DiscountedProductSelectorItemType, DiscountedProductSelectorProductType } from "lib/types/checkout";
import React from "react";
import DiscountedProductCard from "./DiscountedProductCard";
import { CaretDown } from "@phosphor-icons/react";
import { useLocale } from "lib/hooks/useLocale";

interface DiscountedProductGroupProps {
  key: string;
  productGroup: DiscountedProductSelectorItemType;
  groupIndex: number;
  openState: boolean[];
  setOpenState: (openState: boolean[]) => void;
}

const DiscountedProductGroup: React.FC<DiscountedProductGroupProps> = ({
  key,
  productGroup,
  groupIndex,
  openState,
  setOpenState,
}) => {
  const { t } = useLocale();

  const isOpen = openState[groupIndex];

  const toggleOpen = () => {
    const newOpenState = [...openState];
    newOpenState[groupIndex] = !newOpenState[groupIndex];
    setOpenState(newOpenState);
  };

  return (
    <>
      <button 
        onClick={toggleOpen}
        className="flex justify-between p-3 items-center w-full text-coal-dark font-medium text-base"
      >
        <p>
          {isOpen
            ? t("select_any_x", {
                x: productGroup.quantity,
              })
            : t("select_any_x_from_below_y_items", {
                x: productGroup.quantity,
                y: productGroup?.products?.length,
              })}
        </p>
        <div className="flex justify-center items-center space-x-2">
          {isOpen && (
            <span className="text-sm font-normal text-coal-dark">
              {t("x_out_of_y_selected", {
                x: productGroup.selectedQuantity,
                y: productGroup.quantity,
              })}
            </span>
          )}
          <CaretDown
            className={`${isOpen ? "-rotate-180 transform" : ""} h-5 w-5 transition duration-200`}
          />
        </div>
      </button>
      
      {isOpen && (
        <div className="w-full p-3 flex flex-col space-y-3">
          {productGroup?.products?.map(
            (product: DiscountedProductSelectorProductType, pIndex: number) => (
              <DiscountedProductCard
                key={`discounted-product-card-${pIndex + 1}`}
                selectedProduct={product}
                groupIndex={groupIndex}
                productIndex={pIndex}
              />
            ),
          )}
        </div>
      )}
      
      <div className="w-full border-b border-gray-light" />
    </>
  );
};

export default DiscountedProductGroup;
